export function throttle<T extends AnyFunction, Params extends Parameters<T>>(
  func: T,
  delay: number,
): (...args: Params) => void {
  let canRun = true
  let trailingThis: unknown
  let trailingArgs: Params | null = null

  return function (this: unknown, ...args): void {
    if (canRun) {
      func.apply(this, args)
      canRun = false
      const setTimer = (): ReturnType<typeof setTimeout> =>
        setTimeout(() => {
          canRun = true
          if (trailingArgs) {
            // if last arguments exist
            // invoke the function with those last arguments
            func.apply(trailingThis, trailingArgs)
            canRun = false
            trailingArgs = null
            setTimer()
          }
        }, delay)
      setTimer()
    } else {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      trailingThis = this
      trailingArgs = args
    }
  }
}
